import { Box, Card, CardContent, LinearProgress } from "@mui/material";
import { ReactNode } from "react";
import LangSwitcher from "../logic/LangSwitcher";

interface FormScreenProps {
	pending?: boolean,
	header: ReactNode,
	feedback?: ReactNode,
	onSubmit?: () => void,
	children?: ReactNode
}

export default function FormScreen(props: FormScreenProps) {
	return <Box sx={{
		width: '100vw',
		height: '100vh',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#EAEEF3',
	}}>
		<Card
			sx={{ maxWidth: '500px', width: '100%' }}
			component="form"
			onSubmit={(e) => { e.preventDefault(); props.onSubmit && props.onSubmit() }}
		>
			{props.pending
				? <LinearProgress sx={{ height: "8px" }} />
				: <div style={{ height: "8px" }} />
			}

			{props.header}

			{props.feedback && <CardContent sx={{ paddingBottom: 0 }}>
				{props.feedback}
			</CardContent>}

			{props.children}

			<CardContent sx={{ borderTop: '1px #c4c4c4 solid', display: 'flex', justifyContent: 'center' }}>
				<LangSwitcher />
			</CardContent>
		</Card>
	</Box>;
}
